// src/sentry.js
// import * as Sentry from '@sentry/react';
// import { browserTracingIntegration } from '@sentry/browser';
// import React, { useEffect } from 'react';
// import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

// Sentry.init({
//   dsn: 'https://68656afd30cb9fa99c26f8ae7d3bebbb@o4509627150696448.ingest.us.sentry.io/4509627184709632', // replace with your actual DSN
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.reactRouterV6BrowserTracingIntegration({
//       useEffect: React.useEffect,
//       useLocation: require('react-router-dom').useLocation,
//       useNavigationType: require('react-router-dom').useNavigationType,
//       createRoutesFromChildren: require('react-router-dom').createRoutesFromChildren,
//       matchRoutes: require('react-router-dom').matchRoutes,
//       routes: [], // optional, usually not needed unless you're using route objects
//     }),
//   ],
//   tracesSampleRate: 1.0,
// });
// src/sentry/sentry.js
import * as Sentry from "@sentry/react";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const isLocalhost = ["localhost", "127.0.0.1", "::1"].includes(
  window.location.hostname
);
const isProd = process.env.NODE_ENV === "production";

// If you prefer env DSN, set REACT_APP_SENTRY_DSN in your .env
const DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://68656afd30cb9fa99c26f8ae7d3bebbb@o4509627150696448.ingest.us.sentry.io/4509627184709632";

// Initialize only in production & not on localhost
if (isProd && !isLocalhost && DSN) {
  Sentry.init({
    dsn: DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
    // Extra safety: drop anything that somehow slips through on localhost
    beforeSend(event) {
      if (isLocalhost) return null;
      return event;
    },
  });
}

// Helper to only wrap with the profiler in prod/non-local
export const withSentryProfiler = (Component) =>
  isProd && !isLocalhost ? Sentry.withProfiler(Component) : Component;
